import { post, get } from './http';
// 数据字典
export const listDataDic = (params) => get('/wapc/dic/listDataDic', params);
// 铃铛详情查询
export const pageMessageCenter = (params) => post('/wapc/bizMessage/pageMessageCenter', params);

// 铃铛入口-标位已读
export const signAsReadStatus = (params) => post('/wapc/bizMessage/signAsReadStatus', params);

// 消息中心业务数据数量
export const totalQuery = (params) => get('/wapc/bizMessage/totalQuery', params);
